<template>
  <div v-if="show">
    <ModalBasicInfo
      :show="!hasNickname"
      @submit="onBasicInfoSubmit"
      @close="close"
    />
    <ModalRankTest
      :show="hasNickname && !hasRank && !isRankTestClosed && !pendingPrize"
      :initial-selected="initialSelected"
      @close="onRankTestClose"
    />
  </div>
</template>

<script>
import ModalBasicInfo from '@/components/Modal/ModalBasicInfo.vue';
import ModalRankTest from '@/components/Modal/ModalRankTest.vue';
import _ from 'lodash';

// 套用邀請碼後預設給的獎勵：1 個月 / 31 天 VIP
const DEFAULT_PRIZE = {months: 1, days: 31};

export default {
  components: {
    ModalBasicInfo,
    ModalRankTest,
  },
  props: {
    show: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      initialSelected: '',
      isRankTestClosed: false,
      hasGoneBasicInfo: false,
    };
  },
  watch: {
    show: {
      immediate: true,
      handler(val) {
        // 邊緣情境：show 變 true 時，用戶已經有暱稱、卻沒走過 ModalBasicInfo
        // （例如返回用戶 isFirstLogin query 還掛著、但之前流程沒完成過）。
        // 沒有 initialSelected 的話 ModalRankTest 無法顯示 banner，
        // 直接 close 結束流程，避免卡在空白 modal。
        if (val && this.hasNickname && !this.hasGoneBasicInfo) {
          this.close(true);
        }
      },
    },
  },
  computed: {
    userData() {
      return this.$store.getters['user/userData'];
    },
    hasNickname() {
      return this.userData?.nickName && this.userData.nickName !== '-';
    },
    hasRank() {
      return this.userData?.rank;
    },
    pendingPrize() {
      return this.$store.getters['env/pendingPrize'];
    },
  },
  methods: {
    onBasicInfoSubmit({hasPlayed, hasAppliedInviteCode}) {
      // 將「有/沒有學過圍棋」傳給 ModalRankTest 顯示對應 banner。
      this.initialSelected = hasPlayed;
      this.hasGoneBasicInfo = true;
      // 套用邀請碼成功 → 立刻先彈獎勵 modal（在 ModalRankTest banner 之前）。
      if (hasAppliedInviteCode) {
        this.$store.commit('env/setPendingPrize', DEFAULT_PRIZE);
      }
    },
    onRankTestClose() {
      this.isRankTestClosed = true;
      this.close(true);
    },
    close(force) {
      if ((this.hasNickname && this.hasRank) || force) {
        const queryData = _.cloneDeep(this.$route.query);
        delete queryData.isFirstLogin;
        this.$store.commit('user/setIsFirstLogin', false);
        this.$router.replace({query: queryData});
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
